<template>
  <div id="fundsGrowthPromotion">
    <div class="content_box">
      <div class="inner">
        <div class="contact_title">
          <h2>{{ $t('promotion.fundsGrowthPromotion.title') }}</h2>
          <p></p>
        </div>
        <div class="fgp_content">
          <BeforeOptIn
            v-if="!optIn"
            :campaignId="campaignId"
            :redeemableAccounts="redeemableAccounts"
            :tncLink="tncLink"
          />
          <AfterOptIn
            v-if="optIn"
            :campaignId="campaignId"
            :activeAccounts="activeAccounts"
            :selectedActiveAccount="selectedActiveAccount"
            :redeemableAccounts="redeemableAccounts"
            :tncLink="tncLink"
          />
        </div>
        <div class="m-8"></div>
        <div class="bottom_section relative">
          <el-tabs v-model="activeTab" class="demo-tabs" @tab-click="changeTab">
            <el-tab-pane v-for="tab in dynamicTabs" :key="tab.name" :label="tab.label" :name="tab.name">
              <component :is="tab.component" v-bind="tab.props" />
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import History from '@/components/fundsGrowthPromotion/History.vue';
import Faq from '@/components/fundsGrowthPromotion/Faq.vue';
import BeforeOptIn from '@/components/fundsGrowthPromotion/BeforeOptIn.vue';
import AfterOptIn from '@/components/fundsGrowthPromotion/AfterOptIn.vue';
import { FUNDS_GROWTH_PROMO_ID } from '@/constants/promotion';
import { apiCampaignInfo, apiRedeemableAcc } from '@/resource';

export default {
  name: 'FundsGrowthPromotion',
  components: {
    History,
    Faq,
    BeforeOptIn,
    AfterOptIn
  },
  data() {
    return {
      activeTab: 'history',
      btnDisabled: false,
      optIn: false,
      redeemableAccounts: [],
      activeAccounts: [],
      selectedAccount: null,
      selectedActiveAccount: undefined,
      isRTL: false
    };
  },
  computed: {
    campaignId() {
      let campaign = this.$store.state.promotion.eligibleCampaigns.find(c => c.id === FUNDS_GROWTH_PROMO_ID);
      return campaign ? campaign.id : null;
    },
    lang() {
      return this.$store.state.common.lang;
    },
    tncLink() {
      switch (this.lang) {
        case 'zh_CN':
          return 'https://www.vtmarketsglobalcn.com/files/VT_Markets_Active_Trader_Program_Terms_and_Conditions1018_cn.pdf';
        case 'zh_TW':
          return 'https://www.vtmarketsglobal.com/files/VT_Markets_Active_Trader_Program_Terms_and_Conditions1018_tw.pdf';
        default:
          return 'https://www.vtmarkets.com/vt-markets-active-trader-program-promotion/';
      }
    },
    dynamicTabs() {
      const tabs = [
        {
          label: this.$t('promotion.fundsGrowthPromotion.history.title'),
          name: 'history',
          component: 'History',
          props: {
            campaignId: this.campaignId,
            optIn: this.optIn
          }
        },
        {
          label: 'FAQ',
          name: 'faq',
          component: 'Faq',
          props: {}
        }
      ];

      return this.isRTL ? tabs.slice().reverse() : tabs;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.isRTL = document.body.dir === 'rtl';
    });
    this.getCampaignData();
    this.getRedeembleAcc();
  },
  methods: {
    changeTab(tab) {
      this.activeTab = tab.name;
    },
    async getCampaignData() {
      await apiCampaignInfo(this.campaignId).then(resp => {
        if (resp.data.code === 0 && resp.data.data && resp.data.data.participants.length > 0) {
          const isOptInAccounts = resp.data.data.participants.filter(x => x.isOptIn === true);
          if (isOptInAccounts.length > 0) {
            this.optIn = true;
            this.activeAccounts = isOptInAccounts;
            this.selectedActiveAccount = this.activeAccounts[0].mt4Account;
          }
        }
      });
    },

    async getRedeembleAcc() {
      await apiRedeemableAcc(this.campaignId).then(resp => {
        if (resp.data.code === 0 && resp.data.data) {
          this.redeemableAccounts = resp.data.data;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/pages/fundsGrowthPromotion.scss';
</style>
